// extracted by mini-css-extract-plugin
module.exports = {"city":"city-3XhXr","country":"country-29Elq"};